export const CUSTOMER_TERMS_VERSION = "1.0";
export function CustomerTermsContent() {
  return <div className="prose prose-sm max-w-none text-foreground">
      <h2 className="text-xl font-display font-bold text-foreground mb-4">
    </h2>
      <p className="text-sm text-muted-foreground mb-6">Effective Date: January 2025</p>

      <p className="mb-4">
        By registering as a customer ("User," "You"), you agree to the following Terms and Conditions.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">1. Platform Purpose</h3>
      <p className="mb-4">
        Wellness Connect is a digital marketplace and booking platform that connects customers 
        with independent wellness service providers.
      </p>
      <p className="mb-4 font-medium">We do not provide medical or wellness services ourselves.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">2. User Responsibilities</h3>
      <p className="mb-2">You agree to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Provide accurate and truthful information</li>
        <li>Use the platform only for lawful purposes</li>
        <li>Respect businesses and platform policies</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">3. No Medical Advice Disclaimer</h3>
      <p className="mb-2">Content, listings, or information on the platform:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Are not medical advice</li>
        <li>Should not replace professional medical consultation</li>
      </ul>
      <p className="mb-4 font-medium">Always consult licensed professionals when necessary.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">4. Bookings & Payments</h3>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Services are delivered by third-party providers</li>
        <li>Payments (if enabled) may be processed through secure payment partners</li>
        <li>Refunds and cancellations are subject to provider policies</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">5. Data Privacy & Consent</h3>
      <p className="mb-2">By registering, you consent to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Collection and processing of personal data (including health-related data if applicable)</li>
        <li>Use of your data for account management, bookings, communications, and platform improvement</li>
        <li>Sharing of necessary data with service providers you engage with</li>
      </ul>
      <p className="mb-4">Processing complies with applicable data protection laws and the Privacy Policy.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">6. User Rights</h3>
      <p className="mb-2">You have the right to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Access, correct, or delete your data</li>
        <li>Withdraw consent (subject to service limitations)</li>
        <li>File a complaint with the relevant data protection authority</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">7. Account Termination</h3>
      <p className="mb-2">We may suspend or terminate accounts for:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Misuse of the platform</li>
        <li>Fraud or abuse</li>
        <li>Violation of these Terms</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">8. Limitation of Liability</h3>
      <p className="mb-2">Wellness Connect is not liable for:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Service quality or outcomes</li>
        <li>Provider actions</li>
        <li>Indirect or consequential losses</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">9. Governing Law</h3>
      <p className="mb-4">These Terms are governed by applicable law.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">10. Acceptance</h3>
      <p className="mb-4">
        By clicking "I Agree", you accept these Terms and the Privacy Policy.
      </p>

      <div className="mt-8 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <h4 className="font-semibold text-foreground mb-2">Data Privacy Consent</h4>
        <p className="text-sm">
          "I consent to the collection, processing, storage, and sharing of my personal information 
          in accordance with applicable data protection laws and the 
          Wellness Connect Privacy Policy."
        </p>
      </div>
    </div>;
}
